import * as joint from '@joint/core'

/**
 * C4 Ellipse shape - oval/elliptical shape
 */
export const C4Ellipse = joint.dia.Element.define(
  'c4.Ellipse',
  {
    size: { width: 240, height: 160 },
    attrs: {
      body: {
        refCx: '50%',
        refCy: '50%',
        refRx: '50%',
        refRy: '50%',
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      nameLabel: {
        refX: '50%',
        refY: '35%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: '50%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Ellipse]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: '65%',
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '70%',
          height: 40,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      { tagName: 'ellipse', selector: 'body' },
      { tagName: 'text', selector: 'nameLabel' },
      { tagName: 'text', selector: 'typeLabel' },
      { tagName: 'text', selector: 'descriptionLabel' },
    ],
  }
)

export function createEllipse(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[${technology}]` : '[Ellipse]'

  const ellipse = new C4Ellipse({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return ellipse
}
